import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalUpdateContentProperty: ExperimentalMutations['experimentalUpdateContentProperty'] =
	(_, { contentId, propertyKey, propertyValue, versionNumber, isDelete }, { network }) => {
		const body = {
			value: propertyValue,
			version: {
				number: versionNumber,
				minorEdit: true,
			},
		};

		const networkRequest = isDelete
			? network.cfetch(`/wiki/rest/api/content/${contentId}/property/${propertyKey}`, {
					method: 'DELETE',
				})
			: fetchJSON(network, `/wiki/rest/api/content/${contentId}/property/${propertyKey}`, {
					method: 'PUT',
					body: JSON.stringify(body),
					headers: {
						'Content-Type': MediaType.JSON,
					},
				});

		return networkRequest.then((res) => {
			if (isDelete) {
				return {
					success: true,
				};
			} else {
				const { id, key, value } = res;

				return {
					success: true,
					id,
					key,
					value,
				};
			}
		});
	};
